<template>
  <div class="buy-vip-wrapper">
    <p class="title">选择会员购买方式</p>
    <div class="item-wrapper">
      <div
        v-show="pricesInfo.friendsHelpInfoShow && pricesInfo.friendsHelpInfoShow.whetherShow"
        @click="action_share()"
        class="item-per"
        :class="{'selItem': curSelItem.groupBuyGoodsId == 0}"
      >
        <img v-if="1" class="logo" :src="require('../../assets/imgs/buy/pay-free.png')" alt />
        <div class="price-wrapper">
          <div class="free">
            <p
              class="free-title"
            >{{pricesInfo.friendsHelpInfoShow && pricesInfo.friendsHelpInfoShow.title}}</p>
          </div>
        </div>
        <div class="desc-wrapper">
          <span>{{pricesInfo.friendsHelpInfoShow && pricesInfo.friendsHelpInfoShow.subheading}}</span>
        </div>
      </div>

      <div
        @click="action_tapItem(item)"
        class="item-per"
        :class="{'selItem': item.groupBuyGoodsId == curSelItem.groupBuyGoodsId}"
        v-for="(item, index) in list"
        :key="index + 1"
      >
        <span class="up-title" v-if="item.subheading">{{item.subheading}}</span>
        <img v-if="item.priceType == 2" class="logo" :src="require('../../assets/imgs/buy/pay-group.png')" alt />
        <div class="price-wrapper">
          <div class="price">
            <span>¥</span>
            <span :class="priceSize(item.price)">{{item.price * 0.01}}</span>
            <span v-if="item.vipType">/{{item.vipType}}</span>
          </div>
        </div>
        <div class="desc-wrapper">
          <span class="desc">{{item.title}}</span>
        </div>
      </div>
      <div
        v-show="pricesInfo.userRelationGuideVO && pricesInfo.userRelationGuideVO.whetherShow"
        @click="action_bind()"
        class="item-per"
      >
        <!-- <img v-if="1" class="logo" src="../../assets/imgs/pay-free.png" alt /> -->
        <div class="price-wrapper">
          <div
            class="relation-title"
          >{{pricesInfo.userRelationGuideVO && pricesInfo.userRelationGuideVO.title}}</div>
          <span>{{pricesInfo.userRelationGuideVO && pricesInfo.userRelationGuideVO.subheading}}</span>
        </div>
      </div>

      <div v-for="(item, index) in restCount" class="item-temp" :key="index + 10"></div>
    </div>
    <van-button class="common-btn btm-btn" plain type="info" @click="action_buy()">{{btnTitle()}}</van-button>
  </div>
</template>

<script>
import { groupBuyGoodsShow } from "@/api/groupbuy";
import { ShareSource } from "@/contants";

export default {
  name: "CommenBuyVip",
  props: {
    childUserId: {
      //''=>给自己付钱, !''=>给孩子付钱
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pricesInfo: {},
      list: [],
      curSelItem: { groupBuyGoodsId: 0 }
    };
  },

  computed: {
    restCount() {
      let showFriendHelp = 0
      let showRelative = 0
      if(this.pricesInfo.friendsHelpInfoShow &&
        this.pricesInfo.friendsHelpInfoShow.whetherShow){
          showFriendHelp = 1
      }
      if(this.pricesInfo.userRelationGuideVO &&
        this.pricesInfo.userRelationGuideVO.whetherShow){
          showRelative = 1
      }
      let itemCount = this.list.length + showFriendHelp + showRelative
      if(itemCount % 3 > 0){
        return 3 - itemCount % 3
      }
      return 0
      // if (
      //   this.pricesInfo.friendsHelpInfoShow &&
      //   this.pricesInfo.friendsHelpInfoShow.whetherShow &&
      //   this.list.length >= 2
      // ) {
      //   return 3 - ((this.list.length + 1) % 3);
      // } else if (this.list.length >= 2) {
      //   return 3 - (this.list.length % 3);
      // } else {
      //   return 0;
      // }
    }
  },

  created() {
    this.request_groupBuyGoodsShow();
  },

  activated() {
    this.request_groupBuyGoodsShow();
  },

  methods: {
    btnTitle() {
      if (
        this.curSelItem.groupBuyGoodsId == 0 &&
        this.pricesInfo.friendsHelpInfoShow
      ) {
        return `邀请${this.pricesInfo.friendsHelpInfoShow.helpPeopleCount}位好友助力`;
      } else {
        return "立即购买";
      }
    },

    priceSize(price) {
      if (price.length <= 2) {
        return "money-num1";
      } else {
        return "money-num2";
      }
    },

    //===============action=============
    //点击购买并充值
    action_buy() {
      this.$emit("itemSeleted");
      setTimeout(() => {
        if (this.curSelItem.groupBuyGoodsId == 0) {
          //免费领取
          if (this.childUserId) {
            //给孩子助力
            this.$router.push({
              path: "/share/freeHaibao",
              query: {
                childUserId: this.childUserId,
                shareSource: ShareSource.ASSIST_PAY_FOR_CHILD
              }
            });
          } else {
            //给自己助力
            this.$router.push({
              path: "/share/freeHaibao",
              query: {
                childUserId: this.childUserId,
                shareSource: ShareSource.ASSIST_RECHARGE
              }
            });
          }
        } else {
          //会员购买
          if (this.childUserId) {
            //给孩子购买
            this.$router.push({
              path: "/payPage",
              query: {
                groupBuyGoodsId: this.curSelItem.groupBuyGoodsId,
                priceType: this.curSelItem.priceType,
                childUserId: this.childUserId
              }
            });
          } else {
            //给自己购买
            this.$router.push({
              path: "/payPage",
              query: {
                groupBuyGoodsId: this.curSelItem.groupBuyGoodsId,
                priceType: this.curSelItem.priceType
              }
            });
          }
        }
      }, 500);
    },

    //点击分享
    action_share() {
      this.curSelItem = { groupBuyGoodsId: 0 };
    },
    action_bind() {
      this.$router.push({
        path: "/selRole"
      });
    },
    //点击item
    action_tapItem(item) {
      this.curSelItem = item;
    },

    //===========net============
    //获取展示的团购商品
    request_groupBuyGoodsShow() {
      groupBuyGoodsShow().then(res => {
        if (res.code == 0) {
          this.pricesInfo = res.data;
          this.list = this.pricesInfo.groupBuyGoodsShows || [];
        } else {
          this.$toast({
            message: res.msg,
            duration: 1000
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../pages/stylesheet/common.styl';

.buy-vip-wrapper {
  & >>> .van-button__text{
    color: #fff;
  }
}

.title {
  margin: 24px auto 0;
  text-align: center;
  font-size: 15px;
}

.item-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.item-per {
  width: 100px;
  height: 130px;
  margin-top: 14px;
  border: 1px solid $common-line-color;
  border-radius: 6px;
  padding: 10px 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .free-info {
    white-space: pre-line;
  }

  .logo {
    position: absolute;
    right: 10px;
    top: 22px;
    width: 20px;
    height: 20px;
    border-radius: 50px;
    justify-content: flex-end;
  }

  .desc-wrapper {
    position: absolute;
    bottom: 10px;
    font-size: 11px;
    color: #A1A1A1;

    .desc {
      text-align: center;
    }
  }

  .up-title {
    position: absolute;
    background-color: $common-blue;
    top: 14px;
    padding: 2px 8px;
    color: #fff;
    font-size: 11px;
    border-radius: 8px;
  }

  .money-num1 {
    font-size: 40px;
  }

  .money-num2 {
    font-size: 30px;
  }
}

.selItem {
  border: 2px solid $common-blue;
}

.item-temp {
  width: 100px;
  height: 130px;
  margin-top: 14px;
}

.btm-btn {
  margin-top: 24px;
}

.free-title {
  white-space: pre-line;
}

.relation-title {
  border-radius: 8px;
  padding: 2px 10px;
  background-color: #f1a232;
  color: white;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// app/components/commonBuyVip/CommenBuyVip.vue